import { render, staticRenderFns } from "./HomeLojas.vue?vue&type=template&id=3b18bc6e"
import script from "../controllers/HomeLojas.ts?vue&type=script&lang=ts&external"
export * from "../controllers/HomeLojas.ts?vue&type=script&lang=ts&external"
import style0 from "./HomeLojas.vue?vue&type=style&index=0&id=3b18bc6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports